<template>
    <span v-html="symbol"></span>
</template>

<script>
export default {
    props : {
        currencyContext : Object,
    },
    computed : {
        symbol () {
            return '&#' + this.currencyContext.unicodedecimal
                .split(', ')
                .join('&#');
        },
    },
}
</script>

<style scoped>

</style>
